import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Grid, Typography, Link, Stack, Avatar, createTheme, ThemeProvider, CardActions, CardContent, Card, CardMedia } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // ใช้สำหรับลิงก์ภายในแอป
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import MainVDO from '../../middles/MainVDO';
import { useMemo } from 'react';
import { get_show_image, travel_guest } from '../../api/API';

// เล่นอัตโนมัติเฉพาะตอนอยู่บนจอ ≥50% เลื่อนออกแล้ว pause — preload="none" ตัวที่ยังไม่เห็นจึงไม่โหลดเลย
function AutoPlayVideo(props) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        const io = new IntersectionObserver(
            ([entry]) => (entry.isIntersecting ? el.play().catch(() => {}) : el.pause()),
            { threshold: 0.5 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return <Box component="video" ref={ref} controls loop muted playsInline preload="none" {...props} />;
}

function Mian_District({ screenWidth, defaultTheme, id, did, data }) {
    const { t, i18n } = useTranslation();
    const districts = t('districts', { returnObjects: true });
    const head_tourist_routes = t('head_tourist_routes', { returnObjects: true });
    const [routes, setRoutes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const menuItems = useMemo(() => MainVDO(did), [did]);

    // หาข้อมูลตาม id
    const selectedDistrict = districts.find((item) => item.id === id);
    const language = i18n.language === 'th' ? selectedDistrict?.name_th : selectedDistrict?.name_en;
    const loadRoute = async () => {
        setLoading(true);
        setError(null); // ✅ Reset error state
        try {
            const { data } = await axios.post(travel_guest, { did });
            console.log("✅ ดึงข้อมูลเส้นทางสำเร็จ:", data);
            setRoutes(data || []);
        } catch (error) {
            console.error("❌ ดึงข้อมูลอำเภอล้มเหลว:", error);
            setError(t('load_data_failed_retry')); // ✅ Set user-friendly error message
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (did) {
                // console.log("if");
                await loadRoute();
            } else {
                // console.log("else");
                setLoading(false);
                setRoutes([]);
            }
        };

        fetchData(); // เรียกใช้ async function ที่เราสร้างไว้
    }, [did, i18n.language]); // ✅ ใส่ did ใน dependency array ให้ถูก

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box
                sx={{
                    width: '100%',
                    minHeight: '100vh', // ✅ ความสูงอย่างน้อยเต็มจอ
                    position: 'relative',
                    backgroundImage: `url('/img-web/ในเมือง_.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    overflowY: 'auto', // ✅ ให้ scroll ได้ตามจริง
                    overscrollBehavior: 'contain', // ✅ ป้องกันการ refresh เมื่อเลื่อนสุด
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        pointerEvents: 'none',
                        zIndex: 1,
                    },
                }}
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        pt: '20px',
                        textAlign: 'center',
                        color: '#ffffff',
                        maxWidth: {
                            xs: '95%',  // 90% บนมือถือ
                            // sm: '80%',  // 80% บนแท็บเล็ต
                            // md: '80%',  // 60% บนเดสก์ท็อป
                        },
                        mx: 'auto', // center horizontally
                    }}
                >
                    < Typography
                        variant="h2"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: {
                                xs: '1.8rem', // มือถือ
                                sm: '2.5rem',
                                md: '3rem',
                            },
                            color: '#ffffff',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                        }}
                    >
                        {head_tourist_routes}
                    </Typography>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: {
                                xs: '1.2rem',
                                sm: '1.8rem',
                                md: '2rem',
                            },
                            color: '#ffffff',
                            wordBreak: 'break-word',
                            whiteSpace: 'normal',
                        }}
                    >
                        {language}
                    </Typography>
                    {/* VDO */}
                    <Box
                        sx={{
                            width: '100%',
                            mx: 'auto',
                            p: 2, // padding น้อยลงสำหรับมือถือ
                            borderRadius: 2,
                        }}
                    >
                        <Grid
                            container
                            spacing={3}
                            justifyContent="center"
                        >
                            {menuItems?.map((item, index) => (
                                <Grid
                                    item
                                    key={index}
                                    xs={12}  // เต็มหน้าจอในมือถือ
                                    sm={6}   // แบ่งครึ่งหน้าจอบนแท็บเล็ต
                                    md={4}   // 3 คอลัมน์ใน desktop
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Card
                                        sx={{
                                            position: 'relative',
                                            width: {
                                                xs: '100%', // เต็มความกว้างบนมือถือ
                                                sm: '100%',
                                                md: '100%', // คงที่เฉพาะบน desktop
                                            },
                                            borderRadius: 4,
                                            overflow: 'hidden',
                                            transition: '0.3s',
                                            '&:hover': {
                                                boxShadow: 6,
                                                transform: 'scale(1.02)',
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                width: '100%',
                                                paddingTop: '56.25%', // 16:9 aspect ratio
                                            }}
                                        >
                                            <AutoPlayVideo
                                                src={item.videoSrc}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    display: 'block',
                                                    zIndex: 1100,
                                                }}
                                            />
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                {/* ROUTE LIST */}
                <Box
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        pt: '20px',
                        textAlign: 'center',
                        color: '#ffffff',
                        maxWidth: {
                            xs: '80%',  // 90% บนมือถือ
                        },
                        mx: 'auto', // center horizontally
                    }}
                >

                    {loading ? (
                        <Typography variant="body1" sx={{ color: 'white' }}>
                            {t('loading')}
                        </Typography>
                    ) : error ? (
                        <Typography variant="body1" sx={{ color: 'red' }}>
                            {error}
                        </Typography>
                    ) : routes?.length > 0 ? (
                        <Grid
                            container
                            spacing={{ xs: 2 }}
                            justifyContent="center"
                        >
                            {routes?.map((route, index) => {
                                // console.log("route", route);

                                return (
                                    <Grid
                                        item
                                        key={route.tid}
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'stretch', // ทำให้ card สูงเท่ากัน ถ้าใส่ content เพิ่มเติม
                                        }}
                                    >
                                        <Card
                                            component={RouterLink}
                                            // to={`/district/${id}/${route.tid}`}
                                            to={`/district/${id}/${route.tid}?index=${index}`}
                                            sx={{
                                                zIndex: 10,
                                                borderRadius: 7,
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                flexDirection: 'column', // ให้ CardMedia กับ Typography เรียงกัน
                                                '&:hover': {
                                                    boxShadow: 6,
                                                    transform: 'scale(1.03)',
                                                },
                                            }}
                                        >
                                            {route?.ImageRoute?.map((img, indexs) => {
                                                // console.log("img", img);
                                                return (
                                                    <CardMedia
                                                        component="img"
                                                        src={`${get_show_image}/${img?.path}`}
                                                        // src={`${BASE_URL}/${route.ImageRoute?.[0]?.path || '/placeholder.jpg'}`}
                                                        alt={route.name}
                                                        sx={{
                                                            // width: '300px',       // กว้างเต็มจอ
                                                            height: '300px',      // สูงเต็มจอ
                                                            objectFit: 'cover',
                                                            display: 'block',
                                                            // transition: 'opacity 0.3s ease-in-out', // จาง
                                                            backgroundColor: '#f0f0f0',
                                                        }}
                                                    />
                                                )

                                            })
                                            }

                                            <CardActions sx={{ justifyContent: 'center' }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        fontSize: '1rem',
                                                        color: 'black',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {route.name}
                                                </Typography>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    ) : (
                        <Box
                            sx={{
                                background: 'white',
                                p: 2,
                                borderRadius: 2,
                                textAlign: 'center',
                                mx: 'auto',
                                my: 3,
                                maxWidth: 400,
                            }}
                        >
                            <Typography variant="body1"
                                sx={{
                                    color: 'green',
                                    fontWeight: 'bold', // หรือใช้ 700 ก็ได 
                                }}>
                                {t('no_route_data')}
                            </Typography>
                        </Box>

                    )}
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default Mian_District